module.exports = __webpack_public_path__ + "img/fig12.e53da954.jpg";